export const CREATED_DEPOSIT = {
  data: {
    id: '6c29447a-0587-48fa-8f01-69e54ba994ed',
    remarks: null,
    auditor_name: null,
    apply_bonus: false,
    is_exchange: false,
    retry_count: 0,
    auto_topup_remark: null,
    bank_transaction_time: null,
    tp_payment_charge: '0',
    audit_time: '2025-07-08T04:13:38.652Z',
    actual_deposit_amount: '100',
    player_id: 'johndoe',
    deposit_amount: '100',
    payment_provider_id: 'dd8580f1-4b32-4df4-ae3f-5853a71dec39',
    company_bank_account_id: 'e9230fdd-828a-4972-9770-c729bf5ab4c0',
    player_bank_account_id: 'ee81d676-6938-45f3-ba5a-9e8d90318e3e',
    account_info: {
      company_bank_account_number: '1621429058',
      company_bank_account_name: 'Chilayout Keoviengkham',
      company_bank_name: 'KBANK',
      player_bank_account_number: '1423659380',
      player_bank_name: {
        'en-US': 'KASIKORNBANK',
        'th-TH': 'ธนาคารกสิกรไทย'
      },
      player_bank_branch: null
    },
    player_confirm_time: '2025-07-08T04:13:38.652Z',
    deposit_status: 1,
    sequence: 99,
    currency: 'THB',
    deposit_type: 3,
    balance_before: '12900',
    balance_after: '4194714.11',
    bank_transaction_log_id: null,
    bank_transaction_id: 'PWK9SDWCMI',
    deposit_reference_id: 'PWK9SDWCMI',
    auto_topup_status: 0,
    from_c: 'THB',
    to_c: 'THB',
    updated_at: new Date().toISOString(),
    created_at: new Date().toISOString(),
    auditor_id: null,
    locked_by: null,
    exchange_rate: null,
    exchange_amount: null,
    promotion_id: null,
    company_crypto_wallet_id: null,
    player_crypto_wallet_id: null,
    company_tp_payment_id: null,
    tp_payment_link: null,
    tp_payment_channel_id: null,
    tp_payment_gateway_id: null,
    agent_user_id: null,
    reward_type: null,
    bonus_amount: '0',
    deposit_id: '6c29447a-0587-48fa-8f01-69e54ba994ed',
    reference_id: 'PWK9SDWCMI',
    bank_info: {
      address: 'null',
      bank_account_id: 'e9230fdd-828a-4972-9770-c729bf5ab4c0',
      bank_account_name: 'Chilayout Keoviengkham',
      bank_account_number: '1621429058',
      bank_branch: 'null',
      bank_name: 'KBANK'
    }
  }
}

export const CANCEL_DEPOSIT = {
  data: { error: false, code: 12004, message: 'Deposit revoked' }
}

export const THIRD_PARTY_PAYMENT_PROVIDER = {
  data: [
    {
      id: 'c50d3843-006a-486d-a05e-d9c60db13ed9',
      name: 'AMB PROD',
      tp_gateway_code: 'third_party_amb_pay',
      sequence: 3,
      channels: [
        {
          id: 'f4a353cc-4605-419b-bbd9-d5ac5029e69e',
          is_maintenance: false,
          is_require_bank: true,
          max_deposit: 100000,
          min_deposit: 10,
          tp_gateway_id: '9dfb2723-f5ff-44d1-bb7e-27cace8b7797',
          code: 'tp_bank_transfer'
        }
      ]
    },
    {
      id: '124d7af4-6bbd-4610-80b1-ed1c98aab547',
      name: 'Fairpays',
      tp_gateway_code: 'third_party_fair_pay',
      sequence: 2,
      channels: [
        {
          id: 'fad29a21-1246-4f0b-aa88-7419fe43128d',
          is_maintenance: false,
          is_require_bank: true,
          max_deposit: 100000,
          min_deposit: 10,
          tp_gateway_id: 'e7e3c6c2-8b2e-4e7e-9b7a-2e9d7b1c4f2a',
          code: 'tp_bank_transfer'
        }
      ]
    }
  ]
}

export const EXCHANGE_RATES = {
  data: { rate: '0.02911', reversed_rate: '35' }
}

export const COMPANY_CRYPTO_WALLET = {
  data: [
    {
      currency: 'USDT',
      network: 'TRC20',
      min_deposit: '0.03',
      max_deposit: '28571.42'
    }
  ]
}

export const CHECK_WITHDRAWAL_EXIST = {
  data: { is_exist: false }
}

export const CREATE_WITHDRAW_REQUEST = {
  data: {
    id: 'e69b8740-6174-4002-ad70-dc527659fc50',
    remarks: null,
    auditor_name: null,
    apply_bonus: false,
    is_exchange: false,
    bank_transaction_id: null,
    retry_count: 0,
    withdrawal_proof_path: null,
    withdrawal_type: 3,
    auto_withdrawal_status: 0,
    promotion_type: 0,
    tp_payment_charge: '0',
    balance_before: '12900',
    balance_after: '4194514.11',
    player_id: 'johndoe',
    agent_uuid: null,
    withdrawal_amount: '100',
    withdrawal_status: 1,
    sequence: 34,
    currency: 'THB',
    player_bank_account_id: 'ee81d676-6938-45f3-ba5a-9e8d90318e3e',
    account_info: {
      player_bank_account_number: '1423659380',
      player_bank_name: {
        'en-US': 'KASIKORNBANK',
        'th-TH': 'ธนาคารกสิกรไทย'
      },
      player_bank_branch: null
    },
    total_turnover: '0',
    total_turnover_left: '0',
    is_turnover_finished: true,
    payment_provider_id: 'dd8580f1-4b32-4df4-ae3f-5853a71dec39',
    total_win_loss: '-5343649.9000',
    from_c: 'THB',
    to_c: 'THB',
    updated_at: '2025-07-08T04:28:42.013Z',
    created_at: '2025-07-08T04:28:42.013Z',
    auditor_id: null,
    audit_time: null,
    locked_by: null,
    player_decline_time: null,
    company_bank_account_id: null,
    actual_withdrawal_amount: null,
    exchange_rate: null,
    exchange_amount: null,
    requested_withdrawal_amount: null,
    auto_withdrawal_remark: null,
    promotion_id: null,
    promotion_type_id: null,
    company_crypto_wallet_id: null,
    player_crypto_wallet_id: null,
    company_tp_payment_id: null,
    tp_payment_channel_id: null,
    tp_payment_gateway_id: null,
    agent_user_id: null,
    reward_type: null,
    bonus_amount: '0',
    promotion_type_reward_id: null,
    bank_name: {
      'en-US': 'KASIKORNBANK',
      'th-TH': 'ธนาคารกสิกรไทย'
    },
    bank_account_number: '1423659380',
    bank_account_phone: null
  }
}

export const CANCEL_WITHDRAWAL_REQUEST = {
  data: { code: 14017, message: 'Withdrawal canceled' }
}

export const CREATE_CRYPTO_WITHDRAW_REQUEST = {
  data: {
    id: '34e0ed4e-ee1b-40d8-82c0-096442466abc',
    remarks: null,
    auditor_name: null,
    apply_bonus: false,
    bank_transaction_id: null,
    retry_count: 0,
    withdrawal_proof_path: null,
    withdrawal_type: 3,
    auto_withdrawal_status: 0,
    promotion_type: 0,
    tp_payment_charge: '0',
    balance_before: '12900',
    balance_after: '4194514.11',
    player_id: 'johndoe',
    agent_uuid: null,
    withdrawal_amount: '100',
    withdrawal_status: 1,
    sequence: 34,
    currency: 'THB',
    player_crypto_wallet_id: 'd4d7a0bf-b938-49f4-9fb5-4f863d29ecf1',
    total_turnover: '0',
    total_turnover_left: '0',
    is_turnover_finished: true,
    payment_provider_id: '07769a0c-97d2-4306-9190-0b57a97a0554',
    total_win_loss: '-5343649.9000',
    from_c: 'THB',
    to_c: 'USDT',
    account_info: {
      player_wallet_address: 'TPNn7ErZqmmENofe9qpX91PwxSNhYrSfM8',
      player_wallet_network: 'TRC20',
      player_wallet_remarks: null
    },
    is_exchange: true,
    exchange_rate: '0.02911',
    exchange_amount: '2.91',
    updated_at: '2025-07-08T04:39:27.475Z',
    created_at: '2025-07-08T04:39:27.475Z',
    auditor_id: null,
    audit_time: null,
    locked_by: null,
    player_decline_time: null,
    company_bank_account_id: null,
    player_bank_account_id: null,
    actual_withdrawal_amount: null,
    requested_withdrawal_amount: null,
    auto_withdrawal_remark: null,
    promotion_id: null,
    promotion_type_id: null,
    company_crypto_wallet_id: null,
    company_tp_payment_id: null,
    tp_payment_channel_id: null,
    tp_payment_gateway_id: null,
    agent_user_id: null,
    reward_type: null,
    bonus_amount: '0',
    promotion_type_reward_id: null
  }
}

export const CREATE_AMB_PAYMENT_RESPONSE = {
  data: {
    id: '31429d32-0309-4083-beb1-42c091051ab0',
    remarks: null,
    auditor_name: null,
    apply_bonus: false,
    is_exchange: false,
    retry_count: 0,
    auto_topup_remark: null,
    bank_transaction_time: null,
    deposit_reference_id: '20250714024335541193',
    tp_payment_charge: '0',
    audit_time: '2025-07-14T02:43:32.220Z',
    actual_deposit_amount: '100',
    player_id: 'yengtst',
    deposit_amount: '100',
    payment_provider_id: '73495bf4-9f3b-49dd-8f87-c1aebd1d1925',
    player_confirm_time: '2025-07-14T02:43:32.220Z',
    deposit_status: 2,
    sequence: 99,
    currency: 'THB',
    from_c: 'THB',
    to_c: 'THB',
    deposit_type: 3,
    balance_before: '4194414.11',
    balance_after: '4194514.11',
    auto_topup_status: 0,
    company_tp_payment_id: 'f4a353cc-4605-419b-bbd9-d5ac5029e69e',
    tp_payment_channel_id: '1d0faa9f-3e75-43a4-a70d-cb3446c31464',
    tp_payment_gateway_id: '9dfb2723-f5ff-44d1-bb7e-27cace8b7797',
    account_info: {
      has_bank: true,
      tp_account_name: 'AMB PROD',
      player_bank_account_number: '98765434567865',
      player_bank_branch: null,
      player_bank_name: {
        'en-US': 'KASIKORNBANK',
        'th-TH': 'ธนาคารกสิกรไทย'
      }
    },
    updated_at: '2025-07-14T02:43:32.257Z',
    created_at: '2025-07-14T02:43:32.257Z',
    auditor_id: null,
    locked_by: null,
    company_bank_account_id: null,
    exchange_rate: null,
    exchange_amount: null,
    promotion_id: null,
    player_bank_account_id: null,
    bank_transaction_id: '20250714024335541193',
    bank_transaction_log_id: null,
    company_crypto_wallet_id: null,
    player_crypto_wallet_id: null,
    tp_payment_link:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/QR_Code_Example.svg/1024px-QR_Code_Example.svg.png',
    agent_user_id: null,
    reward_type: null,
    bonus_amount: '0',
    is_qr: true,
    tp_gateway_code: 'third_party_amb_pay'
  }
}

export const CREATE_CRYPTO_DEPOSIT = {
  data: {
    id: 'e8d49bbe-52ad-4d34-9f9b-6fc196412953',
    remarks: null,
    auditor_name: null,
    apply_bonus: false,
    retry_count: 0,
    auto_topup_remark: null,
    bank_transaction_time: null,
    deposit_reference_id: null,
    tp_payment_charge: '0',
    audit_time: '2025-07-14T07:37:18.558Z',
    actual_deposit_amount: '99.998584',
    player_id: 'yengtst',
    deposit_amount: '3500',
    payment_provider_id: '07769a0c-97d2-4306-9190-0b57a97a0554',
    deposit_status: 1,
    sequence: 99,
    currency: 'THB',
    from_c: 'USDT',
    to_c: 'THB',
    deposit_type: 3,
    balance_before: '4194414.11',
    balance_after: '4197914.11',
    auto_topup_status: 0,
    company_crypto_wallet_id: '3284f2ad-7c5a-4709-92c0-d5e046811a84',
    requested_deposit_amount: '100',
    account_info: {
      company_wallet_address: 'T9yD3SdGrRL5JyMJkVtCCtm5WBrSJLGTCq',
      company_wallet_network: 'TRC20',
      company_wallet_remarks: 'this is for yeng test'
    },
    exchange_amount: '100',
    exchange_rate: '35',
    is_exchange: true,
    updated_at: '2025-07-14T07:37:18.559Z',
    created_at: '2025-07-14T07:37:18.559Z',
    auditor_id: null,
    locked_by: null,
    company_bank_account_id: null,
    promotion_id: null,
    player_bank_account_id: null,
    player_confirm_time: null,
    bank_transaction_id: null,
    bank_transaction_log_id: null,
    player_crypto_wallet_id: null,
    company_tp_payment_id: null,
    tp_payment_link: null,
    tp_payment_channel_id: null,
    tp_payment_gateway_id: null,
    agent_user_id: null,
    reward_type: null,
    bonus_amount: '0',
    crypto_wallet_qr_path:
      'https://static.vecteezy.com/system/resources/previews/005/267/631/non_2x/qr-code-white-icon-vector.jpg',
    crypto_wallet_address: 'T9yD3SdGrRL5JyMJkVtCCtm5WBrSJLGTCq',
    payment_provider_code: 'crypto',
    payment_provider_name: {
      'en-US': 'Crypto',
      'lo-LA': 'Crypto',
      'th-TH': 'Crypto',
      'vi-VN': 'Crypto'
    }
  }
}
